import Vue from 'vue'
import VueRouter from 'vue-router'
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import 'uikit/dist/css/uikit.min.css'
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);
// loads the Icon plugin
UIkit.use(Icons);
import Home from '../views/Home.vue'
import About from "../views/About";
import ProductsServices from "../views/ProductsServices";

import ContactUs from "../views/ContactUs";
import Help from "../views/Help";

Vue.use(VueRouter)

  const routes = [
  { path: '/',  name: 'Home', component: Home },
  { path: '/aboutus',  name: 'About Us', component: About },
  { path: '/productservices',  name: 'Products And Services', component: ProductsServices },
  { path: '/contactus',  name: 'Contact Us', component: ContactUs },
  { path: '/help/videos',  name: 'Help Video', component: Help },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
